import {
  createRouter,
  createWebHistory,
  createWebHashHistory,
  RouteRecordRaw,
} from "vue-router";
import store from "@/store";
import { checkDeadDatetime } from "@/utils/checkDeadDatetime";
import { ElMessage } from "element-plus";

const routes: Array<RouteRecordRaw> = [
  {
    path: "/",
    component: () => import("@/layout/index.vue"),
    redirect: "home",
    children: [
      {
        path: "home",
        name: "Home",
        component: () => import("@/views/home/index.vue"),
        meta: {
          title: "首 页",
        },
      },
      {
        path: "settings",
        name: "Settings",
        component: () => import("@/views/settings/index.vue"),
        meta: {
          title: "医院设置",
        },
      },
      {
        path: "feedback",
        name: "Feedback",
        component: () => import("@/views/feedback/index.vue"),
        meta: {
          title: "关于易聪软件",
        },
      },
      {
        path: "dictTree",
        name: "DictTree",
        component: () => import("@/views/dictTree/index.vue"),
        meta: {
          title: "11.1 通用字典维护",
        },
      },
      {
        path: "cmis_ip_code_bingqu",
        name: "Cmis_ip_code_bingqu",
        component: () => import("@/views/cmis_ip_code_bingqu/index.vue"),
        meta: {
          title: "11.2 住院病区",
        },
      },
      {
        path: "cmis_dept",
        name: "Cmis_dept",
        component: () => import("@/views/cmis_dept/index.vue"),
        meta: {
          title: "11.3 住院科室",
        },
      },
      {
        path: "cmis_ip_code_chuangwei",
        name: "Cmis_ip_code_chuangwei",
        component: () => import("@/views/cmis_ip_code_chuangwei/index.vue"),
        meta: {
          title: "11.4 床位",
        },
      },
      {
        path: "order_tmpl",
        name: "Order_tmpl",
        component: () => import("@/views/order_tmpl/index.vue"),
        meta: {
          title: "11.5 检查检验模版",
        },
      },
      {
        path: "cmis_ip_diag_tmpl",
        name: "Cmis_ip_diag_tmpl",
        component: () => import("@/views/cmis_ip_diag_tmpl/index.vue"),
        meta: {
          title: "11.6 全院诊断模版",
        },
      },
      {
        path: "cmis_ip_emr_de",
        name: "Cmis_ip_emr_de",
        component: () => import("@/views/cmis_ip_emr_de/index.vue"),
        meta: {
          title: "11.7 数据元",
        },
      },
      {
        path: "cmis_ip_emr_ds",
        name: "Cmis_ip_emr_ds",
        component: () => import("@/views/cmis_ip_emr_ds/index.vue"),
        meta: {
          title: "11.8 数据集",
        },
      },
      {
        path: "cmis_ip_emr_ctrl",
        name: "Cmis_ip_emr_ctrl",
        component: () => import("@/views/cmis_ip_emr_ctrl/index.vue"),
        meta: {
          title: "11.9 病历控件",
        },
      },
      {
        path: "cmis_ip_emr_tmpl",
        name: "Cmis_ip_emr_tmpl",
        component: () => import("@/views/cmis_ip_emr_tmpl/index.vue"),
        meta: {
          title: "11.10 病历模版",
        },
      },
      {
        path: "cmis_ip_route",
        name: "Cmis_ip_route",
        component: () => import("@/views/cmis_ip_route/index.vue"),
        meta: {
          title: "11.11 给药途径",
        },
      },
      {
        path: "cmis_ip_frequency",
        name: "Cmis_ip_frequency",
        component: () => import("@/views/cmis_ip_frequency/index.vue"),
        meta: {
          title: "11.12 给药频次",
        },
      },
      {
        path: "order_tmpl_1",
        name: "Order_tmpl_1",
        component: () => import("@/views/order_tmpl_1/index.vue"),
        meta: {
          title: "11.13 全院医嘱模版",
        },
      },
      {
        path: "cmis_ip_emr_qa_rule",
        name: "Cmis_ip_emr_qa_rule",
        component: () => import("@/views/cmis_ip_emr_qa_rule/index.vue"),
        meta: {
          title: "11.14 病案评分规则",
        },
      },
      {
        path: "charge",
        name: "Charge",
        component: () => import("@/views/charge/index.vue"),
        meta: {
          title: "11.16 收费项目",
        },
      },
      {
        path: "cmis_ip_rytz",
        name: "Cmis_ip_rytz",
        component: () => import("@/views/cmis_ip_rytz/index.vue"),
        meta: {
          title: "12.1 住院通知单",
        },
      },
      {
        path: "rydj_form",
        name: "Rydj_form",
        component: () => import("@/views/rydj_form/index.vue"),
        meta: {
          title: "13.1 入院登记",
        },
      },
      {
        path: "cmis_ip_rydj",
        name: "Cmis_ip_rydj",
        component: () => import("@/views/cmis_ip_rydj/index.vue"),
        meta: {
          title: "13.2 住院记录",
        },
      },
      {
        path: "cmis_ip_deposit",
        name: "Cmis_ip_deposit",
        component: () => import("@/views/cmis_ip_deposit/index.vue"),
        meta: {
          title: "13.3 押金管理",
        },
      },
      {
        path: "discharge",
        name: "Discharge",
        component: () => import("@/views/discharge/index.vue"),
        meta: {
          title: "13.4 住院结算",
        },
      },
      {
        path: "cmis_patientinfo",
        name: "Cmis_patientinfo",
        component: () => import("@/views/cmis_patientinfo/index.vue"),
        meta: {
          title: "13.5 患者信息",
        },
      },
      {
        path: "cmis_ip_invoice",
        name: "Cmis_ip_invoice",
        component: () => import("@/views/cmis_ip_invoice/index.vue"),
        meta: {
          title: "13.6 发票管理",
        },
      },
      {
        path: "chs_log",
        name: "Chs_log",
        component: () => import("@/views/chs_log/index.vue"),
        meta: {
          title: "13.7 医保冲正",
        },
      },
      {
        path: "cmis_ip_order_fee",
        name: "Cmis_ip_order_fee",
        component: () => import("@/views/cmis_ip_order_fee/index.vue"),
        meta: {
          title: "13.8 报表",
        },
      },
      {
        path: "doctor_home",
        name: "Doctor_home",
        component: () => import("@/views/doctor_home/index.vue"),
        meta: {
          title: "14.1 我的患者",
        },
      },
      {
        path: "cmis_ip_zhenduan_tmpl",
        name: "Cmis_ip_zhenduan_tmpl",
        component: () => import("@/views/cmis_ip_zhenduan_tmpl/index.vue"),
        meta: {
          title: "14.3 诊断模板",
        },
      },
      {
        path: "drug_back_apply",
        name: "Drug_back_apply",
        component: () => import("@/views/drug_back_apply/index.vue"),
        meta: {
          title: "14.4 退药申请",
        },
      },
      {
        path: "check_discharge",
        name: "Check_discharge",
        component: () => import("@/views/check_discharge/index.vue"),
        meta: {
          title: "14.5 出院核查",
        },
      },
      {
        path: "print_order",
        name: "Print_order",
        component: () => import("@/views/print_order/index.vue"),
        meta: {
          title: "14.6 医嘱打印",
        },
      },
      {
        path: "cmis_ip_report_critical",
        name: "Cmis_ip_report_critical",
        component: () => import("@/views/cmis_ip_report_critical/index.vue"),
        meta: {
          title: "14.7 危级值",
        },
      },
      {
        path: "cmis_ip_apply",
        name: "Cmis_ip_apply",
        component: () => import("@/views/cmis_ip_apply/index.vue"),
        meta: {
          title: "14.8 报告查询",
        },
      },
      {
        path: "cmis_ip_bed",
        name: "Cmis_ip_bed",
        component: () => import("@/views/cmis_ip_bed/index.vue"),
        meta: {
          title: "15.1 床位图",
        },
      },
      {
        path: "handle_order",
        name: "Handle_order",
        component: () => import("@/views/doctor_home/index.vue"),
        meta: {
          title: "15.2 医嘱处理",
        },
      },
      {
        path: "vital_signs",
        name: "Vital_signs",
        component: () =>
          import("@/views/cmis_ip_bed/components/Temperature.vue"),
        meta: {
          title: "15.4 体征录入",
        },
      },
      {
        path: "order_fee",
        name: "Order_fee",
        component: () => import("@/views/order_fee/index.vue"),
        meta: {
          title: "15.5 费用查询",
        },
      },
      {
        path: "nurse_order_fee",
        name: "Nurse_order_fee",
        component: () => import("@/views/nurse_order_fee/index.vue"),
        meta: {
          title: "15.6 补费退费",
        },
      },
      {
        path: "nurse_case_record",
        name: "Nurse_case_record",
        component: () => import("@/views/nurse_case_record/index.vue"),
        meta: {
          title: "15.7 护理病历",
        },
      },
      {
        path: "cmis_ip_apply_appointment",
        name: "Cmis_ip_apply_appointment",
        component: () => import("@/views/cmis_ip_apply_appointment/index.vue"),
        meta: {
          title: "16.4 医技预约",
        },
      },
      {
        path: "cmis_ip_unqualified_sample",
        name: "Cmis_ip_unqualified_sample",
        component: () => import("@/views/cmis_ip_unqualified_sample/index.vue"),
        meta: {
          title: "16.6 不合格样品",
        },
      },
      {
        path: "report",
        name: "Report",
        component: () => import("@/views/report/index.vue"),
        meta: {
          title: "17.8 报表",
        },
      },
      {
        path: "zy_yf_fzy",
        name: "Zy_yf_fzy",
        component: () => import("@/views/zy_yf_fzy/index.vue"),
        meta: {
          title: "18.1 住院发中药",
        },
      },
      {
        path: "zy_yf_fxy",
        name: "Zy_yf_fxy",
        component: () => import("@/views/zy_yf_fxy/index.vue"),
        meta: {
          title: "18.2 住院发西药",
        },
      },
      {
        path: "zy_yf_kc_cx",
        name: "zy_yf_kc_cx",
        component: () => import("@/views/zy_yf_kc_cx/index.vue"),
        meta: {
          title: "18.3 住院库存查询",
        },
      },
      {
        path: "zy_yf_ypjoinkc",
        name: "Zy_yf_ypjoinkc",
        component: () => import("@/views/zy_yf_ypjoinkc/index.vue"),
        meta: {
          title: "18.4 住院退药处理",
        },
      },
      {
        path: "zy_yf_if_ruku",
        name: "Zy_yf_if_ruku",
        component: () => import("@/views/zy_yf_md_ruku/index.vue"),
        meta: {
          title: "18.5 住院入库",
        },
      },
      {
        path: "no_found",
        name: "No_found",
        component: () => import("@/views/no_found/index.vue"),
        meta: {
          title: "404",
        },
      },
    ],
  },
  {
    path: "/login",
    name: "Login",
    component: () => import("../views/login/index.vue"),
    meta: {
      hidden: true,
      title: "登录",
    },
  },
  {
    path: "/forget",
    name: "Forget",
    component: () => import("@/views/forget/index.vue"),
    meta: {
      hidden: true,
      title: "忘记密码",
    },
  },
  {
    path: "/sign_canvas",
    name: "SignCanvas",
    component: () => import("@/views/signCanvas/index.vue"),
    meta: {
      title: "签名",
    },
  },
  {
    path: "/dataScreen",
    name: "DataScreen",
    component: () => import("@/views/dataScreen/index.vue"),
    meta: {
      title: "数据大屏",
    },
  },
];

// 路由白名单
const whiteRoutes = [
  "Login",
  "Forget",
  // "Settings",
];

const router = createRouter({
  // history: createWebHashHistory(process.env.BASE_URL),
  // history: createWebHistory(process.env.BASE_URL),
  history:
    process.env.VUE_APP_ROUTER_MODE === "hash"
      ? createWebHashHistory(process.env.BASE_URL)
      : createWebHistory(process.env.BASE_URL),
  routes,
  scrollBehavior(to, from, savedPosition) {
    // 滚动到顶部
    return { top: 0 };
  },
});

router.beforeResolve((to: any, from, next) => {
  const isFileProtocol = window.location.protocol === "file:";

  if (to.path === "/") {
    if (isFileProtocol) {
      // 如果是 file:// 协议，使用相对路径
      return next("./login");
    } else {
      // 正常情况下使用绝对路径
      return next("/login");
    }
  }

  let token = localStorage.getItem("token") || '';
  let token_data: any = localStorage.getItem("token_time");
  let diff = new Date(token_data).getTime() - new Date().getTime();
  if (!whiteRoutes.includes(to.name) && (!token || diff < 0)) {
    if (!token || diff < 0) {
      ElMessage.error("令牌授权已过期，请重新登陆！");
      localStorage.removeItem("token");
      localStorage.removeItem("token_time");
    }
    if (isFileProtocol) {
      // 如果是 file:// 协议，使用相对路径
      next("./login?redirect=" + encodeURIComponent(to.path));
    } else {
      // 正常情况下使用绝对路径
      next("/login?redirect=" + encodeURIComponent(to.path));
    }
    store.dispatch("clearInfo", {}).then(() => {
      next(`/login?redirect=${to.path}`);
    }); // 清空用户信息
  } else {
    // if (to.path === "/iframes" && to.query.his && to.query.targetName) {
    //   // 表示住院菜单
    //   const newTitle = to.query.targetName;
    //   to.meta.title = newTitle;
    // }
    next();
  }
  if (!whiteRoutes.includes(to.name)) {
    checkDeadDatetime();
  }
});

export default router;
